import { MeetingType, Compare, Day, MeetingIssue } from '@/types.d';

const times = [
  { label: '12:00 AM', value: '000' },
  { label: '1:00 AM', value: '100' },
  { label: '2:00 AM', value: '200' },
  { label: '3:00 AM', value: '300' },
  { label: '4:00 AM', value: '400' },
  { label: '5:00 AM', value: '500' },
  { label: '6:00 AM', value: '600' },
  { label: '7:00 AM', value: '700' },
  { label: '8:00 AM', value: '800' },
  { label: '9:00 AM', value: '900' },
  { label: '10:00 AM', value: '1000' },
  { label: '11:00 AM', value: '1100' },
  { label: '12:00 PM', value: '1200' },
  { label: '1:00 PM', value: '1300' },
  { label: '2:00 PM', value: '1400' },
  { label: '3:00 PM', value: '1500' },
  { label: '4:00 PM', value: '1600' },
  { label: '5:00 PM', value: '1700' },
  { label: '6:00 PM', value: '1800' },
  { label: '7:00 PM', value: '1900' },
  { label: '8:00 PM', value: '2000' },
  { label: '9:00 PM', value: '2100' },
  { label: '10:00 PM', value: '2200' },
  { label: '11:00 PM', value: '2300' },
];

const compares: { label: string; value: Compare }[] = [
  { label: 'Anytime', value: null },
  { label: 'Before', value: '<' },
  { label: 'After', value: '>=' },
  { label: 'At', value: '=' },
];

const typeEntries = Object.entries(MeetingType);

const types: { label: string; value: MeetingType }[] = typeEntries.map(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ([key, value]) => {
    return { label: key, value: value as MeetingType };
  }
)!;

const days: { label: string; value: Day }[] = [
  { label: 'Mon', value: 'Monday' },
  { label: 'Tues', value: 'Tuesday' },
  { label: 'Weds', value: 'Wednesday' },
  { label: 'Thurs', value: 'Thursday' },
  { label: 'Fri', value: 'Friday' },
  { label: 'Sat', value: 'Saturday' },
  { label: 'Sun', value: 'Sunday' },
];

const meetingIssues = [
  { label: 'Meeting no longer exists', value: MeetingIssue.DOES_NOT_EXIST },
  { label: 'Meeting time is incorrect', value: MeetingIssue.TIME_INCORRECT },
  {
    label: 'Meeting location is incorrect',
    value: MeetingIssue.LOCATION_INCORRECT,
  },
  { label: 'Meeting type is incorrect', value: MeetingIssue.TYPE_INCORRECT },
  { label: 'Other issue', value: MeetingIssue.OTHER },
];

export { times, types, days, compares, meetingIssues };
